import httpClient from './httpClient';

const td_action = () => httpClient.get('/api/td_action');

export {
    td_action
}